import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail } from "lucide-react";
import { CONTACT } from "@/data/site";
import { Reveal, Chapter } from "@/components/motion";

export default function CTASection({ title = "Ready to Build Your Workforce?", compact = false }) {
  return (
    <section className="relative overflow-hidden bg-navy" data-testid="cta-section">
      <div className="absolute inset-0 bg-blueprint-dark opacity-40" />
      <div className="absolute -right-24 -top-24 h-96 w-96 rotate-12 border-[28px] border-gold/10" />
      <div className={`relative z-10 mx-auto max-w-7xl px-6 ${compact ? "py-20" : "py-28 lg:py-36"}`}>
        <Chapter index="—" label="Talk to Formcore" dark />
        <Reveal delay={0.1}>
          <h2 className="mt-8 max-w-3xl font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl">
            {title}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/70">
            Whether you need a small number of personnel or are planning a larger workforce deployment,
            our team can discuss your requirements and develop an appropriate workforce solution.
          </p>
        </Reveal>
        <Reveal delay={0.3} className="mt-10 flex flex-wrap items-center gap-4">
          <Link
            to="/contact"
            data-testid="cta-request-workforce-btn"
            className="inline-flex items-center gap-2 bg-gold px-8 py-4 font-heading text-sm font-bold uppercase tracking-[0.12em] text-navy transition-colors duration-200 hover:bg-gold-dark active:scale-[0.97]"
          >
            Request Workforce
            <ArrowUpRight className="h-4 w-4" />
          </Link>
          <a
            href={CONTACT.phoneHref}
            data-testid="cta-call-btn"
            className="inline-flex items-center gap-2 border border-white/30 px-8 py-4 font-heading text-sm font-bold uppercase tracking-[0.12em] text-white transition-colors duration-200 hover:border-gold hover:text-gold active:scale-[0.97]"
          >
            <Phone className="h-4 w-4" />
            Call {CONTACT.phone}
          </a>
          <a
            href={CONTACT.emailHref}
            data-testid="cta-email-link"
            className="inline-flex items-center gap-2 px-2 py-4 text-sm font-semibold text-white/60 transition-colors hover:text-gold"
          >
            <Mail className="h-4 w-4" />
            {CONTACT.email}
          </a>
        </Reveal>
      </div>
    </section>
  );
}
